module.exports = __webpack_public_path__ + "static/media/javascript icon.7697f2f8.svg";